var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-switcher" }, [
    _c(
      "a",
      {
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            _vm.opened = !_vm.opened
          },
        },
      },
      [
        _vm._v(_vm._s(_vm.currentConfig.name)),
        _c("i", { staticClass: "img icon-triangle-white-8" }),
      ]
    ),
    _vm.opened
      ? _c(
          "div",
          { staticClass: "droplist" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v("Selecteer een applicatie"),
            ]),
            _c("span", { staticClass: "active" }, [
              _vm._v(_vm._s(_vm.currentConfig.name)),
            ]),
            _vm._l(_vm.appConfigs, function (app) {
              return _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.switchApp(app)
                    },
                  },
                },
                [_vm._v(_vm._s(app.name))]
              )
            }),
            _c("div", { staticClass: "logout" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.logout.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Uitloggen")]
              ),
            ]),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }